const initialState = [];

const ecoSettings = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case "ECO_SETTINGS_RECEIVED": {
            return payload;
        }
        default:
            return state;
    }
};

export default ecoSettings;
